import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PromoMaterialsTable {
    .ReactDataTable__wrapper {
      .ReactDataTable {
        tr {
          grid-template-columns:
            minmax(50px, 0.6fr) /* preview */
            minmax(120px, 1fr) /* type */
            minmax(120px, 1fr) /* size */
            minmax(200px, 2fr) /* campaignName */
            minmax(120px, 1fr) /* language */
            minmax(100px, 1fr); /* actions */
        }

        .ReactDataTable__tbody-row {
          height: 65px;
        }

        .ReactDataTable__tbody-cell {
          display: flex;
          align-items: center;

          &:first-child {
            justify-content: center;

            .PromoMaterialsTable__logo {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              object-fit: cover;
            }
          }

          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(5) {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &:nth-child(4) {
            flex: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;

      span {
        text-align: center;
        padding: 5px 0;

        &:first-child {
          flex: 2; /* preview */
        }

        &:nth-child(2) {
          flex: 8; /* campaignName */
        }

        &:nth-child(3) {
          flex: 3; /* actions */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:first-child {
          flex: 2;
          justify-content: center;

          .PromoMaterialsTable__logo {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        &:nth-child(2) {
          flex: 8; /* campaignName */
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
        }

        &:nth-child(3) {
          flex: 3;
          justify-content: center;
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .PromoMaterialsTable {
    }
  `;
};

export { staticStyles, getDynamicStyles };
